import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  listItem: {
    paddingLeft: 10
  }
}))
